import moment from 'moment-timezone'
import * as R from 'ramda'

export function getTimezones() {
  return R.filter((z: any) => z && z.indexOf('/') > -1 && z.indexOf('Etc/') < 0, moment.tz.names())
}
